module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Ki-Ld.3ed50b71.png";